import React from 'react';
import { offer } from '../data/offer';
type OfferBlockProps = {
  onCheckout: () => void;
};
export function OfferBlock({
  onCheckout
}: OfferBlockProps) {
  return <div className="rounded-[14px] p-6" style={{
    border: '3px solid #12A05A',
    backgroundColor: '#F1E6D6'
  }} data-id="element-25" data-mp="dtamyxfx7xdr">
      <div className="flex flex-wrap items-baseline justify-center gap-x-3 gap-y-2" data-id="element-26" data-mp="4ugrjaebtd1s">
        <span className="text-[20px] font-medium text-ink/40 line-through" data-id="element-27" data-mp="skt9le3acq63">
          ${offer.compareAt}
        </span>
        <span className="text-[46px] font-extrabold leading-none text-ink" data-id="element-28" data-mp="wmei6n8seiah">${offer.price}</span>
        <span className="text-[12px] font-bold uppercase tracking-[0.04em] text-[#12A05A]" data-id="element-29" data-mp="iv9mtxcgcc5y">
          Save {offer.savePercent}%
        </span>
      </div>

      <p className="mt-2 text-center text-[13px] text-ink/60" data-id="element-30" data-mp="nrqbqtrh6uk3">
        One-time payment · Lifetime access
      </p>

      <ul className="mx-auto mt-6 max-w-[420px] space-y-3 text-left text-[15px]" data-id="element-31" data-mp="1ga5fa3zemg3n">
        {offer.features.map(feature => <li key={feature.label} className="flex items-start gap-2" data-id="element-32" data-mp="2zlwz2jngo4ae">
            <span aria-hidden="true" className="flex-none leading-[1.5] text-[#12A05A]" data-id="element-33" data-mp="2vktni9cg4uez">
              ✓
            </span>
            <span className={feature.bold ? 'font-extrabold text-ink' : 'text-ink'} data-id="element-34" data-mp="39crry6v7q24t">
              {feature.label}
            </span>
          </li>)}
      </ul>

      <button type="button" onClick={onCheckout} className="mt-7 w-full rounded-[999px] bg-[#12A05A] px-5 py-4 text-[17px] font-extrabold text-white transition-[background-color,transform] duration-150 ease-out hover:bg-[#0E8C4E] active:translate-y-[1px] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink" data-id="element-35" data-mp="34josji3r7ygp">
        GET INSTANT ACCESS →
      </button>
    </div>;
}